import { app } from '../../bootstrap/core';
import { startState } from './start.state';
import { startComponent } from './start.component';
import { NewBankModel } from './bank.model';
import { Accounts } from './accounts';
import '../../common/ui/modals/cheatsheet.tpl.html';

app.config(startState);
app.component(startComponent.name, startComponent);
app.factory('NewBankModel', () => NewBankModel);
app.service('Accounts', () => Accounts);



// WEBPACK FOOTER //
// ./src/app/components/start/start.js